import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'
import {
  validateUaetOrdererInfoStep,
  validateUaetSpouseInfoStep,
  validateUaetUsageRegionStep,
  validateUaetAdditionalSelectionStep,
  validateUaetContactInfoStep,
} from 'todistukset-common/src/vtj/uaet-validation'
import {
  OnClickParams,
  Step,
  StepButtons,
} from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { refreshSession } from 'todistukset-ui/src/vtj/stores/actions/session-timer-actions'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'
import UaetInstructionsStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetInstructionsStep.react'
import UaetOrdererInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetOrdererInfoStep.react'
import UaetSpouseInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetSpouseInfoStep.react'
import UaetUsageRegionStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetUsageRegionStep.react'
import UaetAdditionalSelectionStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetAdditionalSelectionStep.react'
import UaetContactInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetContactInfoStep.react'
import UaetSummaryStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetSummaryStep.react'
import UaetOrderCompleteStep from 'todistukset-ui/src/vtj/components/order-wizard-uaet/UaetOrderCompleteStep.react'
import { isFree } from 'todistukset-ui/src/vtj/components/order-wizard-uaet/uaet-price'
import { useUaetForm } from 'todistukset-ui/src/vtj/stores/uaet-form.store'
import { useSubmitUaetOrdererForm } from 'todistukset-ui/src/vtj/stores/actions/uaet-form-actions'

// eslint-disable-next-line @typescript-eslint/no-empty-function
function doNothing(): void {}

const refreshOnClick = ({ onSuccess }: OnClickParams): void => {
  refreshSession()
  onSuccess()
}

const getRefreshOnClick = () => refreshOnClick

export function getUaetSteps(): Step[] {
  const steps = [
    {
      name: StepRoutes.UAET_INSTRUCTIONS,
      component: UaetInstructionsStep,
      validations: [],
      onPrevClick: doNothing,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.NEXT,
    },
    {
      name: StepRoutes.UAET_ORDERER_INFO,
      component: UaetOrdererInfoStep,
      validations: [validateUaetOrdererInfoStep],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.UAET_SPOUSE_INFO,
      component: UaetSpouseInfoStep,
      validations: [validateUaetSpouseInfoStep],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.UAET_USAGE_REGION,
      component: UaetUsageRegionStep,
      validations: [validateUaetUsageRegionStep],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.UAET_ADDITIONAL_SELECTIONS,
      component: UaetAdditionalSelectionStep,
      validations: [validateUaetAdditionalSelectionStep],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.UAET_CONTACT_INFO,
      component: UaetContactInfoStep,
      validations: [validateUaetContactInfoStep],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.UAET_SUMMARY,
      component: UaetSummaryStep,
      validations: [],
      onPrevClick: refreshOnClick,
      useOnNextClick: useSubmitUaetOrdererForm,
      buttons: StepButtons.PREV_AND_CUSTOM_NEXT,
      useCustomNextButton: () => {
        const form = useUaetForm()
        return isFree({
          includeApostille:
            finalEditableFieldValue(form.includeApostille) ?? false,
          includeTranslationForm:
            finalEditableFieldValue(form.includeTranslationForm) ?? false,
        })
          ? StepButtons.PREV_AND_CONFIRM
          : StepButtons.PREV_AND_ORDER
      },
    },
    {
      name: StepRoutes.UAET_ORDER_COMPLETE,
      component: UaetOrderCompleteStep,
      validations: [],
      onPrevClick: doNothing,
      useOnNextClick: () => doNothing,
      buttons: StepButtons.NONE,
    },
  ]
  return steps.map((step, index) => {
    return {
      ...step,
      index,
      getPath: (lang = LanguageCode.FI) =>
        `/${lang}/${PageRoutes.UAETTODISTUS}/${step.name}`,
    }
  })
}
